'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = require('../Link');

var _Link2 = _interopRequireDefault(_Link);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = require('../../utils/prefix');

var _prefix2 = _interopRequireDefault(_prefix);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classes = (0, _prefix2.default)('FloatingActionButton--');

var FloatingActionButton = function FloatingActionButton(_ref) {
  var pull = _ref.pull,
      small = _ref.small,
      large = _ref.large,
      className = _ref.className,
      icon = _ref.icon,
      props = (0, _objectWithoutProperties3.default)(_ref, ['pull', 'small', 'large', 'className', 'icon']);
  return _react2.default.createElement(
    _Link2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)('unstyled FloatingActionButton', classes({ pull: pull, small: small, large: large }), className)
    }, props),
    icon
  );
};

var bool = _propTypes2.default.bool,
    element = _propTypes2.default.element,
    string = _propTypes2.default.string;


FloatingActionButton.propTypes = {
  pull: bool,
  small: bool,
  large: bool,
  icon: element,
  className: string
};

exports.default = FloatingActionButton;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/FloatingActionButton/index.js
// module id = 618
// module chunks = 0